import { Component, ViewChild, Injector, Output, EventEmitter} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { finalize } from 'rxjs/operators';
import { LocationsesServiceProxy, CreateOrEditLocationsDto, DropDown, DropdownServicesServiceProxy, FtbImage, Logodto, TenantSettingsEditDto, SettingScopes } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
//import * as moment from 'moment';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { IAjaxResponse } from '@abp/abpHttpInterceptor';
import { TokenService } from '@abp/auth/token.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConsts } from '@shared/AppConsts';
import { ImageCroppedEvent } from 'ngx-image-cropper';

import { appModuleAnimation } from '@shared/animations/routerTransition';
@Component({
    selector: 'createOrEditLocationsModal',
    templateUrl: './create-or-edit-locations-modal.component.html'
})
export class CreateOrEditLocationsModalComponent extends AppComponentBase {
       imageExist: boolean = false;

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    state: DropDown[];
isCropEnabled: boolean = false;
    usingDefaultTimeZone = false;
    initialTimeZone: string = null;
    testEmailAddress: string = undefined;  
    isMultiTenancyEnabled: boolean = this.multiTenancy.isEnabled;
    showTimezoneSelection: boolean = abp.clock.provider.supportsMultipleTimezone;
    activeTabIndex: number = (abp.clock.provider.supportsMultipleTimezone) ? 0 : 1;
    loading = false;

    settings: TenantSettingsEditDto = undefined;
    logoUploader: FileUploader;
    customCssUploader: FileUploader;
    remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;
    aspectRatio: number = 1;
    defaultTimezoneScope: SettingScopes = SettingScopes.Tenant;
    selectedFiles: FileList;
    fileName: string;
    imageChangedEvent:Event | null=null;
    croppedImage:any='';
    profile:any;
    iamgeUrl:any='';
    public imagePath;
    EmployeeEditable:boolean=false;
    flag:boolean;
    // EmployeeStatus:boolean=false;
   type:string;
   saving: boolean;
   logo: Logodto = new Logodto();
   active:boolean=false;
    isCropped: boolean;
    originalImage: string;
    ratio: number;
    originalftp: string;
    updateaddress:any;
    tenantAddress: any;
    isLoading: boolean;
    tenantApiClient: any;
    result: string;
    tenancyLogo: any;
    isFileValid: boolean = false;
    enableDisable: boolean = false;

    locations: CreateOrEditLocationsDto = new CreateOrEditLocationsDto();



    constructor(
        injector: Injector,
        private _locationsesServiceProxy: LocationsesServiceProxy,
                private _dropdownServiceProxy: DropdownServicesServiceProxy,private sanitizer: DomSanitizer
        
    ) {
        super(injector);
    }
    onShown(): void {

        document.getElementById('Locations_Name').focus();
    }
        ftp=new FtbImage();
    
    isValidBase64(str: string): boolean {
        try {
            return btoa(atob(str)) === str;
        } catch (err) {
            return false;
        }
    }
    

    onSelectFile(event: any): void {
            this.enableDisable = true;
            this.imageChangedEvent = event;
            this.selectedFiles = event.target.files;
            this.type = this.selectedFiles[0].type;
        
            // Check for valid image types
            if (this.type === "image/jpeg" || this.type === "image/png" || this.type === "image/gif") {
                     this.flag=true;
                     this.isFileValid = true;
                this.fileName = this.selectedFiles[0].name;
                this.ftp = new FtbImage();
                this.ftp.name = this.fileName;
        
                let file = event.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
        
                // Automatically set to circle crop and process
                reader.onload = () => {
                    this.originalImage = reader.result as string;
                    this.profile = reader.result;
                    this.originalftp=reader.result!.toString().split(',')[1];
                    this.ftp.ftbData = reader.result!.toString().split(',')[1];   
                };             
            } else {
                this.isFileValid = false;
                this.notify.error("Invalid file type. Please upload a JPEG, PNG, or GIF image.");
                event.target.value = '';
            }
        }
        
        imageCropped(event: ImageCroppedEvent): void {
            if (this.isCropped) { 
               
                this.croppedImage = event.base64;
        
                
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const size = 128; 
                canvas.width = size;
                canvas.height = size;
        
                if (ctx) {
                    const image = new Image();
                    image.src = event.base64 || '';
                    image.onload = () => {
                        ctx.beginPath();
                        ctx.arc(size / 2, size / 2, size / 2, 0, 2 * Math.PI);
                        ctx.clip();
                        ctx.drawImage(image, 0, 0, size, size);
        
                        // Convert to base64 string
                        const circularBase64 = canvas.toDataURL('image/png');
                        this.profile = circularBase64;
                        this.ftp.ftbData = circularBase64.split(',')[1]; 
                    };
                }
            } else if (this.ratio && this.ratio !== 1) {
                // Rectangle crop logic
                this.croppedImage = event.base64;
                const base64String = this.croppedImage.split(',')[1];
        
             
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const width = 256; 
                const height = width / this.ratio; 
                canvas.width = width;
                canvas.height = height;
        
                if (ctx) {
                    const image = new Image();
                    image.src = event.base64 || '';
                    image.onload = () => {
                        ctx.drawImage(image, 0, 0, width, height);
        
                        const rectangularBase64 = canvas.toDataURL('image/png');
                        this.profile = rectangularBase64; 
                        this.ftp.ftbData = rectangularBase64.split(',')[1]; 
                    };
                }
            } else {
               
                this.croppedImage = event.base64;
                const base64String = this.croppedImage.split(',')[1];
                this.profile = event.base64;
        
                if (this.isValidBase64(base64String)) {
                    this.ftp.ftbData = base64String;
                    this.profile = this.sanitizer.bypassSecurityTrustUrl(this.profile);
                } else {
                    this.notify.error('Invalid Base64 string.');
                }
            }
        }
        enableCropping(): void {
            if (this.imageChangedEvent) {
                this.isCropEnabled = true;
              } else {
                this.notify.error('Please select an image first.');
              }
            }
        Default(event){
            this.isCropEnabled = false;
            this.isCropped = false; 
            this.croppedImage = null; 
            this.ftp.ftbData =this.originalftp;
            this.profile = this.originalImage;
        }
        setCropShape(shape: string): void {
            this.enableCropping();
            if (shape === 'circle') {
                this.isCropped = true;
              
            } else if (shape === 'square') {
                this.isCropped = false;
               
            }
        }
    show(locationsId?: number): void {
    
this.filterstate();
        if (!locationsId) {
            this.locations = new CreateOrEditLocationsDto();
            this.locations.id = locationsId;

            this.active = true;
            this.modal.show();
        } else {
            this._locationsesServiceProxy.getLocationsForEdit(locationsId).subscribe(result => {
                this.locations = result.locations;

       if(result.locations.logoFileType){
       
                this.imageExist = true;
                this.tenancyLogo =  AppConsts.ftpUrl + "/logoImage/" + result.locations.logoFileType;
            }
            else {
                        this.imageExist = false;
            }
       

                this.active = true;
                this.modal.show();
            });
        }
        
    }
    clearLogo(): void {
         this.isCropEnabled = false;
            this.logo.iamgeUrl=null;
            this.isCropped = false; 
            this.ftp.name = null;
            this.type = null;
           this.enableDisable = false;
            let file = null;
            this.croppedImage = null;
            this.selectedFiles=null; 
            this.ftp.ftbData =null;
            this.isFileValid = false;
            this.profile = null;
            this.imageExist = false;
            this.flag = false;
            const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
            if (fileInput) {
                fileInput.value = ''; 
            }
            this.notify.info(this.l('Deleted Successfully'));
    
}

changeLogo(): void {
    this.imageExist = false;
    this.enableDisable = true;
    this.flag = false;
    this.notify.info('Please select a new image to upload.');
}
 filterstate() {
        this._dropdownServiceProxy
            .getStateData()
            .subscribe((Customer) => {
                this.state = Customer;
            });
    }
    save(): void {
            this.saving = true;
            debugger;
        this.locations.logoname = this.fileName;
        this.locations.iamgeUrl = this.ftp.ftbData;  
        this.locations.logoFileType = this.type;
            this._locationsesServiceProxy.createOrEdit(this.locations)
             .pipe(finalize(() => { this.saving = false;}))
             .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
             });
    }







    close(): void {
        this.isCropEnabled = false;
            this.logo.iamgeUrl=null;
            this.isCropped = false; 
            this.ftp.name = null;
            this.type = null;
           this.enableDisable = false;
            let file = null;
            this.croppedImage = null;
            this.selectedFiles=null; 
            this.ftp.ftbData =null;
            this.isFileValid = false;
            this.profile = null;
            this.imageExist = false;
            this.flag = false;
            const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
            if (fileInput) {
                fileInput.value = ''; 
            }
        this.active = false;
        this.modal.hide();
    }
}
